export default "__VITE_ASSET__68c07f40__"